
import { Options, Vue } from "vue-class-component";
import DetailLayout from "@/app/ui/layout/detail-layout.vue";
import {
  checkRolePermission,
  dateToDateString,
  dateToTime,
  formatDate,
  formatByCountry,
  parseByCountry,
} from "@/app/infrastructures/misc/Utils";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import { CargoData, CargoDetailStt, DimensionCustomData } from "@/domain/entities/Cargo";
import { CargoController } from "@/app/ui/controllers/CargoController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import Print from "../modules/print.vue";
import {
  ModalMessageEntities,
  QueryParamsEntities2
} from "@/domain/entities/MainApp";
import router from "@/app/ui/router";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ReadyToCargoController } from "@/app/ui/controllers/ReadyToCargoController";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import moment from "moment";
import PreviewImagePod from "../../shipment/tracking-stt-cargo/tracking-stt-tab/component/preview-image-pod.vue";
import { NGenController } from "../../../controllers/NGenController";
import { FlagsPermissionIncomingOutgoing } from "@/feature-flags/flag-incoming-outgoing";


@Options({
  components: {
    DetailLayout,
    Title,
    Print,
    PreviewImagePod
  }
})
export default class Detail extends Vue {
  confirmationCancelCargo() {
    CargoController.setCancelFromDetail(true);
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        title: this.$t("Apakah anda yakin ingin membatalkan?"),
        message: this.$t(
          'Jika memilih "Ya" sistem akan membatalkan proses booking'
        ),
        textCancel: this.$t("Ya"),
        textSuccess: this.$t("Tidak"),
        onSubmit: () => MainAppController.closeMessageModal(),
        onClose: () => this.cancelCargo(),
        image: "badge-confirmation-general"
      })
    );
  }

  confirmationDeleteCargo() {
    CargoController.setDeleteFromDetail(true);
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        title: this.$t("Apakah anda yakin ingin menghapus?"),
        message: this.$t(
          "Data yang sudah dihapus akan hilang dari daftar Dibatalkan/Gagal"
        ),
        textCancel: this.$t("Ya"),
        textSuccess: this.$t("Tidak"),
        onSubmit: () => MainAppController.closeMessageModal(),
        onClose: () => this.deleteCargo(),
        image: "badge-confirmation-general"
      })
    );
  }

  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  get partnerName() {
    return this.detailData.partnerName || "-";
  }



  get partnerType() {
    return this.detailData.partnerType || "-";
  }

  get originCity() {
    return this.detailData.originCityCode && this.detailData.originCityName
      ? `${this.detailData.originCityCode} - ${this.detailData.originCityName}`
      : "-";
  }

  get destinationCity() {
    return this.detailData.destinationCityCode &&
      this.detailData.destinationCityName
      ? `${this.detailData.destinationCityCode} - ${this.detailData.destinationCityName}`
      : "-";
  }

  get cargoType() {
    return this.detailData.cargoType || "-";
  }

  get destinationAirport() {
    if (
      !this.detailData.airportDestinationCityCode ||
      !this.detailData.airportDestinationCityName
    ) {
      return "-";
    }
    return this.detailData.cargoType === "plane"
      ? `${this.detailData.airportDestinationCityCode} - ${this.detailData.airportDestinationCityName}`
      : "-";
  }

  get cargoCommodity() {
    return this.detailData.cargoCommodity || "-";
  }

  get cargoProduct() {
    return this.detailData.cargoProduct || "-";
  }

  get nog() {
    return this.detailData.nog || "-";
  }

  get cargoNumberOrBookingRequestId() {
    return this.detailData.bookingRequestId || this.detailData.cargoNumber;
  }

  get vehiclePoliceNumber() {
    return this.detailData.vehiclePoliceNumber || "-";
  }

  get departureDate() {
    return formatDate(this.detailData.departureDate);
  }

  get arrivalDate() {
    return formatDate(this.detailData.arrivalDate);
  }

  get totalStt() {
    return this.detailData.totalStt ? this.detailData.totalStt.toString() : "-";
  }

  get totalPieces() {
    return this.detailData.totalPieces
      ? this.detailData.totalPieces.toString()
      : "-";
  }

  get totalEstCargoGrossWeight() {
    return this.detailData.totalEstCargoGrossWeight
      ? `${this.convertDecimalWithComma(
          this.detailData.totalEstCargoGrossWeight
        )} Kg`
      : "-";
  }

  get totalEstCargoVolumeWeight() {
    return this.detailData.totalEstCargoVolumeWeight
      ? `${this.convertDecimalWithComma(
          this.detailData.totalEstCargoVolumeWeight
        )} Kg`
      : "-";
  }

  get totalGrossWeight() {
    return this.detailData.totalGrossWeight
      ? `${this.convertDecimalWithComma(this.detailData.totalGrossWeight)} Kg`
      : "-";
  }

  get totalVolumeWeight() {
    return this.detailData.totalVolumeWeight
      ? `${this.convertDecimalWithComma(this.detailData.totalVolumeWeight)} Kg`
      : "-";
  }

  get totalActualCargoGrossWeight() {
    return this.detailData.totalActualCargoGrossWeight
      ? `${this.formatValueNumber(
          this.detailData.totalActualCargoGrossWeight
        )} Kg`
      : "-";
  }

  get totalActualCargoVolumeWeight() {
    return this.detailData.totalActualCargoVolumeWeight
      ? `${this.formatValueNumber(
          this.detailData.totalActualCargoVolumeWeight
        )} Kg`
      : "-";
  }

  get cargoActualPiece() {
    return this.detailData.cargoActualPiece
      ? this.detailData.cargoActualPiece.toString()
      : "-";
  }

  get cargoTotalChargeableWeight() {
    return this.detailData.cargoTotalChargeableWeight
      ? `${this.convertDecimalWithComma(this.detailData.cargoTotalChargeableWeight)} Kg`
      : "-";
  }

  get cargoTotalCustomChargeableWeight() {
    return this.detailData.cargoTotalCustomChargeableWeight
      ? `${this.convertDecimalWithComma(this.detailData.cargoTotalCustomChargeableWeight)} Kg`
      : "-";
  }

  get cargoTotalEstimateChargeableWeight() {
    return this.detailData.cargoTotalEstimateChargeableWeight
      ? `${this.convertDecimalWithComma(this.detailData.cargoTotalEstimateChargeableWeight)} Kg`
      : "-";
  }

  get configTimeoutCancelCargo() {
    return FlagsPermissionCargo.config_time_cancel_cargo.getValue();
  }

  get isButtonAble() {
    return FlagsPermissionCargo.feature_flight_v2_enable.isEnabled();
  }

  dateTimeNow = moment();

  get diffMinutesDateTime() {
    if (this.configTimeoutCancelCargo === 0) return true;
    const created = this.$moment(this.detailData.createdAt);
    const now = this.dateTimeNow;
    const diff = now.diff(created, "minutes");
    return diff >= this.configTimeoutCancelCargo;
  }

  get isAbleToCancel() {
    return this.detailData.cargoStatus.includes("process") && this.diffMinutesDateTime
  }

  get isDg() {
    return (
      this.detailData.cargoType === "plane" &&
      (this.detailData.cargoCommodityGroupIsDg ||
        this.detailData.cargoCommodityGroupIsElectronicDg)
    );
  }

  get isQuarantine() {
    return (
      this.detailData.cargoType === "plane" &&
      this.detailData.cargoCommodityGroupIsQuarantine
    );
  }

  get isDisputeCargo() {
    return this.detailData.isDisputeCargo;
  }

  get isPti() {
    return (
      this.detailData.cargoType === "plane" &&
      FlagsPermissionCargo.permission_cargo_print_pti_pdf.isEnabled()
    );
  }

  get isSptj() {
    return (
      this.detailData.cargoType === "plane" &&
      this.detailData.cargoCommodityGroupIsDg &&
      !this.detailData.cargoCommodityGroupIsElectronicDg &&
      FlagsPermissionCargo.permission_cargo_print_sptj_pdf.isEnabled()
    );
  }

  get isSptjElektronik() {
    return (
      this.detailData.cargoType === "plane" &&
      this.detailData.cargoCommodityGroupIsElectronicDg &&
      FlagsPermissionCargo.permission_cargo_print_electronic_sptj_pdf.isEnabled()
    );
  }

  get createdAt() {
    return formatDate(this.detailData.createdAt);
  }

  get createdBy() {
    return this.detailData.createdBy || "-";
  }

  get shcValue() {
    return (
      `${this.detailData.shcCode} - ${this.detailData.shcDescription}` || "-"
    );
  }

  get ableToEdit() {
    const isIncomingOutgoing = FlagsPermissionIncomingOutgoing.permission_incoming_outgoing_cargo_detail_legacy_edit.isEnabled() 
    return isIncomingOutgoing || (
      FlagsPermissionCargo.permission_cargo_detail_edit.isEnabled()
    );
  }

  get showDetailKoli() {
    return (
      this.detailData.cargoType === "plane" &&
      this.detailData.isPlaneManual === false &&
      this.detailData.cargoDimensionCustom?.[0]?.sttOrBag
    );
  }
  async mounted() {
    if (this.detailData.id) {
      await this.$router.replace({query: {id: this.detailData.id}});
    }
    this.fetchDetailData();
    this.refs = this.$refs;
    this.startIntervalDateTime();
    
  }

  unmounted() {
    CargoController.resetCargoData();
    this.stopInterval();
  }

  dateTimeInterval = null as any;

  startIntervalDateTime() {
    this.dateTimeInterval = setInterval(() => {
      this.dateTimeNow = moment();
    }, 1000);
  }

  stopInterval() {
    clearInterval(this.dateTimeInterval);
  }

  get cargoNo(): string {
    return decodeURIComponent(String(this.$route.params?.id));
  }

  get cargoId(): string | number {
    return this.$route.query.id as string;
  }

  get rcNo(): string {
    return decodeURIComponent(String(this.$route.query?.rc_no));
  }

  get isFromListFailedBooking() {
    return this.$route.query.rc_no;
  }

  fetchDetailData() {
    const isPrint = false;
    if (this.$route.query.rc_no) {
      CargoController.getDetailRetryCargo({
        cargoNo: this.rcNo,
        isPrint: isPrint
      });
    } else {
      CargoController.getDetailCargo({
        id: this.cargoId,
        isPrint: isPrint
      });
    }
  }

  get detailData(): CargoData {
    return CargoController.cargoDetailData;
  }

  get accountData() {
    return AccountController.accountData;
  }

  get isLoading() {
    return CargoController.isLoading;
  }

  get isError() {
    return CargoController.isError;
  }
  get errorCause() {
    return CargoController.errorCause;
  }

  get totalDimension() {
    if (
      !this.detailData.actualDimension.length ||
      !this.detailData.actualDimension.width ||
      !this.detailData.actualDimension.height
    ) {
      return "-";
    }
    return `
      ${this.detailData.actualDimension.length} x 
      ${this.detailData.actualDimension.width} x 
      ${this.detailData.actualDimension.height} CM
    `;
  }

  get isSttEmpty() {
    return !this.detailData.detailStt.length;
  }

  showModalReBooking = false;
  handlerModalReBooking(val: boolean) {
    this.showModalReBooking = val;
  }

  goToReBooking() {
    const bookingQueryObject = {
      autofill: true,
      rcId: this.$route.query.rc_no
    };
    const bookingQuery = new QueryParamsEntities2(bookingQueryObject);
    router.push(`/cargo/create?${bookingQuery.queryString}`);
    ReadyToCargoController.setFlowBooking("rebooking");
    CargoController.setIsDeleteStt(false);
    this.handlerModalReBooking(false);
  }

  handlerCancelCargo(id: number, cargoNo: string) {
    CargoController.setCargoIdToCancelOrDelete(id);
    CargoController.setCargoNoForModal(cargoNo);
  }

  handlerDeleteCargo(id: number, cargoNo: string) {
    CargoController.setCargoIdToCancelOrDelete(id);
    CargoController.setCargoNoForModal(cargoNo);
  }

  // table
  get columns() {
    return [
      {
        name: "No.",
        styleHead: "w-12 text-left whitespace-nowrap text-black-lp-300",
        render: (_: CargoDetailStt, i: number) =>
          `<span class="font-normal text-black-lp-300 whitespace-nowrap">${i +
            1}</span>`
      },
      {
        name: "No. bag",
        styleHead: "w-64 text-left whitespace-nowrap text-black-lp-300",
        render: (item: CargoDetailStt) =>
          `<div class="font-normal text-black-lp-300 whitespace-normal break-all">${item.baggingVendorNumber ||
            item.baggingNumber ||
            "-"}</div>`,
        key: "actionable_column",
        validateIcon: true,
        showIcon: (item: CargoDetailStt) =>
          (item.baggingVendorNumber || item.baggingNumber) &&
          item.isDisputeBagging,
        showButton: () => true,
        icon: "kg-dispute",
        iconStyle: "ml-1",
        iconColor: "red-lp-100",
        iconTooltip: () => "Bag dengan selisih berat"
      },
      {
        name: "Chargeable<br>bag",
        styleHead: " w-32 text-left whitespace-nowrap text-black-lp-300",
        render: (item: CargoDetailStt) =>
          `<div class="font-normal text-black-lp-300 whitespace-normal break-all">${item.bagData.bagCustomChargeableWeight ? this.decimalNumberColumnData(item.bagData.bagCustomChargeableWeight) : "-"}</div>`
      },
      {
        name: "No. STT",
        styleHead: "w-48 text-left whitespace-nowrap text-black-lp-300",
        render: (item: CargoDetailStt) => {
          return `<div class="text-black-lp-300 whitespace-normal break-all">
                  ${item.sttNumber || "-"}
                </div>`;
        }
      },
      {
        name: "No. referensi",
        styleHead: "w-48 text-left whitespace-nowrap text-black-lp-300",
        render: (item: CargoDetailStt) => {
          return `<div class="text-black-lp-300 whitespace-normal break-all">
                  ${item.sttNoRefExternal || "-"}
                </div>`;
        }
      },
      {
        name: "Chargeable<br>weight STT",
        styleHead: " w-32 text-left whitespace-nowrap text-black-lp-300",
        render: (item: CargoDetailStt) => {
          return `<div class="text-black-lp-300 whitespace-normal break-all">
                  ${item.chargeableWeight || "-"} kg
                </div>`;
        }
      },
      {
        name: "Berat<br>kotor STT",
        styleHead: "w-32 text-left whitespace-nowrap text-black-lp-300",
        render: (item: CargoDetailStt) =>
          `<span class="font-normal text-black-lp-300 whitespace-normal break-all">${
            item.sttGrossWeight
          } kg</span>`
      },
      {
        name: "Berat<br>volume STT",
        styleHead: "w-32 text-left whitespace-nowrap text-black-lp-300",
        render: (item: CargoDetailStt) =>
          `<span class="font-normal text-black-lp-300 whitespace-normal break-all">${
            item.sttVolumeWeight
          } kg</span>`
      },
      {
        name: "Koli",
        styleHead: "w-24 text-left whitespace-nowrap text-black-lp-300",
        render: (item: CargoDetailStt) =>
          `<span class="font-normal text-black-lp-300 whitespace-nowrap">${
            item.sttTotalPiece || "-"
          }</span>`
      },
      {
        name: "Jenis<br>pengiriman",
        styleHead: "w-32 text-left whitespace-normal break-all text-black-lp-300",
        render: (item: CargoDetailStt) => {
          return `<div class="text-black-lp-300 rounded capitalize  px-2 py-0 bg-gray-lp-1400 whitespace-normal break-all">
                  ${item.sttProductType || "-"}
                </div>`;
        }
      },
      {
        name: "Komoditas",
        styleHead: " w-40 text-left whitespace-normal break-all text-black-lp-300",
        render: (item: CargoDetailStt) => {
          return `<div class="text-black-lp-300 whitespace-normal break-all">
                  ${item.sttCommodityName || "-"}
                </div>`;
        }
      },
      {
        name: "Kota tujuan",
        styleHead: " w-48 text-left whitespace-normal break-all text-black-lp-300",
        render: (item: CargoDetailStt) => {
          return `<div class="text-black-lp-300 rounded capitalize  px-2 py-0 bg-gray-lp-1400 whitespace-normal break-all">
                  ${item.destination || "-"}
                </div>`;
        }
      },
    ];
  }

  get columnsPieces() {
    return [
      {
        name: "No. STT/bag",
        styleHead: "w-30 text-left whitespace-nowrap",
        render: (item: DimensionCustomData) =>
          `<span class="font-normal text-12px text-black-lp-300 whitespace-nowrap">${item.sttOrBag}</span>`
      },
      {
        name: this.$t("Berat kotor"),
        styleHead: "w-30 text-left whitespace-nowrap",
        render: (item: DimensionCustomData) =>
          `<span class="font-normal text-12px text-black-lp-300 whitespace-nowrap">${this.decimalNumberColumnData(
            item.grossWeight
          )}</span>`
      },
      {
        name: this.$t("Dimensi/paket (P x L x T)"),
        styleHead: "w-30 text-left whitespace-nowrap",
        render: (item: DimensionCustomData) =>
          `<span class="font-normal text-12px text-black-lp-300 whitespace-nowrap">
            ${this.convertDecimalWithComma(item.length) || "-"} x ${this.convertDecimalWithComma(item.width) || "-"} x ${this.convertDecimalWithComma(item.height) || "-"} cm
          </span>`
      },
      {
        name: this.$t("Berat volume"),
        styleHead: "w-30 text-left whitespace-nowrap",
        render: (item: DimensionCustomData) =>
          `<span class="font-normal text-12px text-black-lp-300 whitespace-nowrap">
            ${item.volumeWeight}
          </span>`
      },
    ];
  };

  pagination = {
    page: 1,
    limit: 100
  };

  // route navigatiion
  goBack() {
    const path =
      (this.$route.meta as any)["parent-path"] || this.$route.matched[0].path;
    this.$router.push(path);
  }
  goToEdit() {
    const idQuery = this.cargoId ? `?id=${this.cargoId}` : "";
    this.$router.push(`${this.$route.path}/edit${idQuery}`);
  }

  convertDecimalWithComma(value: any) {
    return formatByCountry(Number(value), { type: "weight", country: this.countryCode });
  }

  decimalNumberColumnData(number: number | string) {
    const decimalNumber = Number(number);
    return decimalNumber !== 0 ? `${formatByCountry(decimalNumber, { type: "weight", country: this.countryCode })} kg` : "-";
  }

  totalPiecesColumnData(total: number) {
    return total != 0 ? total : "-";
  }

  formatValueNumber(number: any) {
    const val = typeof number === "string"
      ? parseByCountry(number, { country: this.countryCode })
      : number;
    return formatByCountry(val, { type: "weight", country: this.countryCode });
  }

  // Print
  check = null;
  refs: any = "";
  cargoNumber = "";

  async printPdf() {
    this.refs.print.printManifestV2(this.detailData.id);
    this.cargoNumber = this.cargoNo;
  }

  async printLabel(cargoNo: string, type: string) {
    this.refs.print.printData(this.detailData.id, "label", type);
    this.cargoNumber = this.cargoNo;
  }

  async printAWBLionCargo(AWBNo: string) {
    NGenController.printAWBLionCargo({ AWBNo: AWBNo });
  }

  async printSPTJ(cargoNo: string) {
    (this.$refs.print as any).printSptjNonElectronic(this.detailData.id);
    this.cargoNumber = cargoNo;
  }

  async printPti(cargoNo: string) {
    (this.$refs.print as any).printPtiPdf(this.detailData.id);
    this.cargoNumber = cargoNo;
  }

  async printSPTJElektronik(cargoNo: string) {
    (this.$refs.print as any).printSPTJElektronik(this.detailData.id);
    this.cargoNumber = cargoNo;
  }

  async printManifestV2(cargoNo: string) {
    (this.$refs.print as any).printManifestV2(this.detailData.id);
    this.cargoNumber = cargoNo;
  }

  async downloadManifest(id: number) {
    await CargoController.getDownloadData({ id: id, type: "cargo" });
  }

  cancelCargo() {
    CargoController.cancelCargo();
    this.handlerModalCancelBooking(false);
  }
  deleteCargo() {
    CargoController.deleteCargo();
    this.handlerModalDeleteBooking(false);
  }
  showModalCancelBooking = false;
  handlerModalCancelBooking(val: boolean) {
    this.showModalCancelBooking = val;
  }
  showModalDeleteBooking = false;
  handlerModalDeleteBooking(val: boolean) {
    this.showModalDeleteBooking = val;
  }

  get totalDisputeBagging() {
    return this.detailData.totalDisputeBagging;
  }

  get totalBagging() {
    return this.detailData.totalBagging;
  }

  // photo proof
  isPreviewPhotoProof = false;

  get isAWBLionCargo() {
    return this.detailData.cargoType === "plane";
  }
}
